import React from "react";
import { RISK_COLORS, LEVEL_LABELS } from "@/lib/risk";
import { cn } from "@/lib/utils";

export default function StatusBadge({ level, label, className, size = "md" }) {
    const c = RISK_COLORS[level] || RISK_COLORS.green;
    const sz = size === "sm" ? "text-[10px] px-1.5 py-0.5" : "text-xs px-2 py-0.5";
    return (
        <span
            className={cn("inline-flex items-center gap-1 rounded-md font-semibold uppercase tracking-wide", sz, className)}
            style={{ background: c.bg, color: c.text, border: `1px solid ${c.border}` }}
        >
            <span className="h-1.5 w-1.5 rounded-full" style={{ background: c.hex }} />
            {label || LEVEL_LABELS[level]}
        </span>
    );
}
